// removed by extract-text-webpack-plugin
module.exports = {"deleteRow":"DeleteFreemiumAccount-deleteRow","deleteButton":"DeleteFreemiumAccount-deleteButton"};